/**
 * @generated SignedSource<<d4a1f7c19d191b7a44fa84c45d831d81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActorItem_actor$data = {
  readonly __typename: "Guild";
  readonly " $fragmentSpreads": FragmentRefs<"GuildItem_guild">;
  readonly " $fragmentType": "ActorItem_actor";
} | {
  readonly __typename: "User";
  readonly " $fragmentSpreads": FragmentRefs<"UserItem_user">;
  readonly " $fragmentType": "ActorItem_actor";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "ActorItem_actor";
};
export type ActorItem_actor$key = {
  readonly " $data"?: ActorItem_actor$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActorItem_actor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "displayMyRelationStatus"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActorItem_actor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "displayFollowingMessage",
              "variableName": "displayMyRelationStatus"
            }
          ],
          "kind": "FragmentSpread",
          "name": "UserItem_user"
        }
      ],
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "displayMembershipStatus",
              "variableName": "displayMyRelationStatus"
            }
          ],
          "kind": "FragmentSpread",
          "name": "GuildItem_guild"
        }
      ],
      "type": "Guild",
      "abstractKey": null
    }
  ],
  "type": "Actor",
  "abstractKey": "__isActor"
};

(node as any).hash = "2c218af16e90eac08caa013c532e8d33";

export default node;
